import React from 'react';
import SEARCH from 'assets/img/search.svg';
import SEARCH_DARK from 'assets/img/black/search.svg';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import { Checkbox, Dropdown, Menu } from 'antd';
import './style.scss';
import './style_dark.scss';
import { CustomIcon, Input } from '../../common';

export const FilterDropdown = ({ chooseFilter }) => (
  <Menu onSelect={e => chooseFilter(e)}>
    <Menu.Item key="1">1st menu item</Menu.Item>
    <Menu.Item key="2">2nd menu item</Menu.Item>
    <Menu.Item key="3">3rd item</Menu.Item>
  </Menu>
);

const AddProviders = ({
  chooseProviderFilter, providerFilter, providerSearchValue, handleInput, isDarkTheme,
}) => (
  <div className="modalContent">
    <h1>Provider Search</h1>
    <div className="row">
      <Dropdown
        style={{ height: '41px' }}
        trigger={['click']}
        overlay={(
          <FilterDropdown
            chooseFilter={chooseProviderFilter}
            filter={providerFilter}
          />)}
      >
        <div className="providers_dropdown">
          <span>Filter by</span> <CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} width="8px" height="10px" />
        </div>
      </Dropdown>
      <div className="providers_input_wrapper">
        <Input
          style={{ height: '41px' }}
          inputProps={{
            type: 'text',
            name: 'providerSearchValue',
            placeholder: 'Search Providers',
            value: providerSearchValue,
            onChange: handleInput,
            style: { height: '41px', fontWeight: 400 },
          }}
          dropdownVisible={false}
          iconSrc={isDarkTheme ? SEARCH_DARK : SEARCH}
        />
      </div>
    </div>
    <div className="providerList">
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
      <Checkbox onChange={() => {}}>Provider</Checkbox>
    </div>
    <div className="footer">
      <div className="pagination" style={{ marginLeft: 'auto' }}>
        <p className="active">1</p>
        <p>2</p>
        <p>3</p>
      </div>
    </div>
  </div>
);

export { AddProviders };



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/AddProviders.js